import { __rest } from 'tslib';
import React from 'react';
import { useColor } from '../../theme/Theme.js';
import { Icon } from '../Icon.js';

const Undo = React.forwardRef((_a, ref) => {
    var { color } = _a, props = __rest(_a, ["color"]);
    const _color = useColor(color);
    return (React.createElement(Icon, Object.assign({ "data-testid": 'tend-ui-undo-icon' }, props, { ref: ref, color: _color }),
        React.createElement("svg", { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'currentColor', xmlns: 'http://www.w3.org/2000/svg' },
            React.createElement("path", { d: 'M9.70711 4.29289C9.31658 3.90237 8.68342 3.90237 8.29289 4.29289L4.29289 8.29289C3.90237 8.68342 3.90237 9.31658 4.29289 9.70711L8.29289 13.7071C8.68342 14.0976 9.31658 14.0976 9.70711 13.7071C10.0976 13.3166 10.0976 12.6834 9.70711 12.2929L7.41421 10H14.0909C16.2326 10 18 11.7735 18 14C18 16.2265 16.2326 18 14.0909 18H8C7.44771 18 7 18.4477 7 19C7 19.5523 7.44771 20 8 20H14.0909C17.3716 20 20 17.2963 20 14C20 10.7037 17.3716 8 14.0909 8L7.41421 8L9.70711 5.70711C10.0976 5.31658 10.0976 4.68342 9.70711 4.29289Z', fill: 'currentColor' }))));
});
Undo.displayName = 'Undo';

export { Undo };
//# sourceMappingURL=Undo.js.map
